import type { RaceOverview } from '../../shared/overview';
import { countdownParts } from '../../shared/results';
import { circuitName, sessionName } from './SessionLibrary';

export default function NextSession({ overview, now }: { overview: RaceOverview | null; now: number }) {
  const next = overview?.next;
  return <div className="next-session" aria-label="下一场赛事">
    <span className="next-label">NEXT SESSION</span>
    {next ? <><strong>{circuitName(next.circuit)} <span>{sessionName(next.sessionName)}</span></strong>
      <span className="next-date">{new Intl.DateTimeFormat('zh-CN', { timeZone: 'Asia/Shanghai', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).format(new Date(next.dateStart))} 北京</span>
      <b className="next-countdown mono">{countdownParts(next.dateStart, now).text}</b></>
      : <span className="next-unknown">{overview ? '下一场赛程等待确认' : '正在确认赛程'}</span>}
    {overview?.stale && <span className="schedule-stale">赛程待更新</span>}
  </div>;
}
